var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnhanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4069_5267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0337 3.03317L16.967 1.9665C16.8732 1.87176 16.7616 1.79656 16.6386 1.74523C16.5156 1.69391 16.3836 1.66748 16.2503 1.66748C16.117 1.66748 15.9851 1.69391 15.8621 1.74523C15.739 1.79656 15.6274 1.87176 15.5337 1.9665L1.96699 15.5332C1.87225 15.6269 1.79705 15.7386 1.74572 15.8616C1.6944 15.9846 1.66797 16.1165 1.66797 16.2498C1.66797 16.3831 1.6944 16.5151 1.74572 16.6381C1.79705 16.7611 1.87225 16.8727 1.96699 16.9665L3.03366 18.0332C3.12684 18.1289 3.23827 18.205 3.36136 18.257C3.48445 18.309 3.61671 18.3358 3.75032 18.3358C3.88394 18.3358 4.01619 18.309 4.13929 18.257C4.26238 18.205 4.37381 18.1289 4.46699 18.0332L18.0337 4.4665C18.1294 4.37332 18.2055 4.26189 18.2575 4.1388C18.3095 4.01571 18.3362 3.88345 18.3362 3.74983C18.3362 3.61622 18.3095 3.48396 18.2575 3.36087C18.2055 3.23778 18.1294 3.12635 18.0337 3.03317Z",
    stroke: "#717182",
    strokeWidth: 1.64706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 5.8335L14.1665 8.3335",
    stroke: "#717182",
    strokeWidth: 1.64706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 5V8.33333",
    stroke: "#717182",
    strokeWidth: 1.64706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 11.6665V14.9998",
    stroke: "#717182",
    strokeWidth: 1.64706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 1.6665V3.33317",
    stroke: "#717182",
    strokeWidth: 1.64706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 6.6665H2.5",
    stroke: "#717182",
    strokeWidth: 1.64706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 13.3335H14.1665",
    stroke: "#717182",
    strokeWidth: 1.64706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 2.5H7.5",
    stroke: "#717182",
    strokeWidth: 1.64706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4069_5267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceIcon);
export default __webpack_public_path__ + "static/media/enhance-icon.71ade070f79aeb28335cb84c56e7acf9.svg";
export { ForwardRef as ReactComponent };